export type ActionError = { error : string };

/**Use this type for all the serveraction functions response Promises */
export type ServerActionResponse<T ={}> = ActionError | undefined | T;

/** Returns true if there is any error with the server action
 * Sever action erros should be handled using this as a condition
 */
export function isActionError(error:any):error is ActionError {
    return error && "error" in error && error
}